module.exports = __webpack_public_path__ + "static/media/launch_anchorage_1.519d4e9c.svg";